import { Dayjs, PluginFunc, UnitType, ManipulateType } from 'dayjs';

declare module 'dayjs' {
  interface Dayjs {
    floor(amount: number, unit: string): Dayjs;
  }
}

const floor: PluginFunc = (option, dayjsClass) => {
  dayjsClass.prototype.floor = function (amount: number, unit: string): Dayjs {
    return this.subtract(this.get(unit as UnitType) % amount, unit as ManipulateType).startOf(unit as ManipulateType);
  };
};

export default floor; 